<div class="snack-bar-container">

    <div class="snackbar-icon">
        @if(data.type === SnackBarType.SUCCESS){
            <mat-icon>check_circle_outline</mat-icon>
        }
        @if(data.type === SnackBarType.ALERT){
            <mat-icon>error_outline</mat-icon>
        }
    </div>

    @if(data.type === SnackBarType.SUCCESS){
        <ng-container [ngTemplateOutlet]="feedback"></ng-container>
    }

    @if(data.type === SnackBarType.ALERT){
        <ng-container [ngTemplateOutlet]="alert"></ng-container>
    }

    <span matSnackBarActions class="snackbar-actions">
        <div matSnackBarAction (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></div>
    </span>
  
</div>


<ng-template #feedback>
   <div matSnackBarLabel innerHtml="{{ data.message | translate : data.params ?? {} | safeHtmlPipe }}" class="snackbar-message"></div>
</ng-template>

<ng-template #alert>
    @if(data.title !== '' && data.message !== 'ERROR'){
        <ng-container [ngTemplateOutlet]="serverError"></ng-container>
    }
    @else {
        <ng-container [ngTemplateOutlet]="errorError"></ng-container>
    }
</ng-template>

<ng-template #serverError>
    <div matSnackBarLabel  class="snackbar-message">
        <div innerHtml="{{ data.title | translate: data.params ?? {} | safeHtmlPipe }}"></div>
        <div innerHtml="{{ data.message | translate : data.params ?? {}  | safeHtmlPipe }}"></div>
    </div>
</ng-template>

<ng-template #errorError>
    <div matSnackBarLabel class="snackbar-message">
        <div innerHtml="{{ data.title | translate: data.params ?? {} | safeHtmlPipe }}"></div>
        <div innerHtml="{{ SERVER_ERROR_TRANSLATION_KEY | translate | safeHtmlPipe }}" #serverErrorText></div>
    </div>
</ng-template>
